import 'utils/lazysizes';
import { picoapp } from 'picoapp';

const app = picoapp();

app.hydrate({
  cart: theme.cart,
});

export default app;
